// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__34800","location":"Header_location__15MvG"};